import { DetailWithIcon } from "@/components/ResourceWithIcon.tsx";
import { VmImageIcon } from "@/modules/compute/VmImageIcon.tsx";
import type { SelectedOs } from "@/modules/compute/os/os.ts";
import { useOsImage, type UseOsImage } from "@/modules/compute/os/useOsImage.ts";
import { Trans } from "@lingui/react/macro";

export function OsInfo({ os }: { os: SelectedOs }) {
    const { image, version } = useOsImage(os);

    return (
        <DetailWithIcon
            title={<OsTitleDisplay image={image} version={version} os={os} />}
            icon={<VmImageIcon image={image} className="color-primary size-0.75rem" />}
        />
    );
}

export function OsTitle({ os }: { os: SelectedOs }) {
    const { image, version } = useOsImage(os);
    return <OsTitleDisplay image={image} version={version} os={os} />;
}

function OsTitleDisplay({ image, version, os }: { os: SelectedOs } & UseOsImage) {
    if (!image && os.os_name === "_custom") {
        return <Trans comment="Custom operating system">Custom</Trans>;
    }

    return `${image?.display_name ?? os.os_name} ${version?.display_name ?? os.os_version}`;
}
